export default {
  title: 'Files',
  dropTitle: 'Drop your file here',
  select: 'or click to choose',

  states: {
    error: 'Loading error',
    success: 'File is loaded',
    loading: 'File is uploading'
  },

  drop: 'Drop your file here'
}
